export default function getFormattedAddress({ address, address2, zip, city }) {
  return `${[address, address2].filter((a) => a).join(' ')}, ${[zip, city].filter((a) => a).join(' ')}`
}
